import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ArrayHelper } from "../../../utilities/contracts/array-helper";
import { GridColumnDefinition } from "../models/grid-column-definition.model";
import { GridConfiguration } from "../models/grid-configuration.model";
import { GridRequest } from "../models/grid-request.model";

// Primeng is forcing us to use an attribute selector.
/* tslint:disable:component-selector */
@Component({
  selector: "[app-grid-header]", // needed to apply the view to <tr> tag
  templateUrl: "./grid-header.component.html",
  styleUrls: ["../grid.component.scss"],
})
export class GridHeaderComponent {
  @Input() configuration: GridConfiguration;
  @Input() request: GridRequest;
  @Output() headerCheckboxToggle = new EventEmitter<any>();

  get filteredColumns(): GridColumnDefinition[] {
    return this.configuration.columns.filter(a => a.show);
  }

  get hasActionButton(): boolean {
    return this.configuration.showActionColumn;
  }

  get hasRowExpansion(): boolean {
    return this.configuration.showRowExpansionColumn;
  }

  get displayHeaderCheckbox(): boolean {
    return this.configuration.isMultipleSelection && this.configuration.showHeaderCheckbox;
  }

  // Only used by grids opted into "select all across pages" (currently the invoice approval grid) — every
  // other grid keeps PrimeNG's stock per-page pTableHeaderCheckbox, untouched.
  get useSelectAllAcrossPagesCheckbox(): boolean {
    return this.configuration.autoSelectPagesWhenAllSelected;
  }

  // Checked only when every matching row in the whole grid (not just this page) is selected.
  get isAllRowsSelected(): boolean {
    return this.request?.isAllSelected && !ArrayHelper.isAvailable(this.request?.excludedKeys);
  }

  onSelectAllAcrossPagesToggle(event: any): void {
    this.headerCheckboxToggle.emit({ checked: event.checked });
  }

  trackByIndex(index, item) {
    return index;
  }
}
/* tslint:enable:component-selector */
